import React from "react";
import { IUser } from "../@shared/types";

export type TSessionContextProps = {
  user: IUser;
  setUser: (user: IUser) => void;
};

export const SessionContext = React.createContext<TSessionContextProps>(null);
